export default __webpack_public_path__ + "static/B101-8c727fea63c66451558a178cd4586601.jpg";